import React from "react";
import HOME_SEO from "../homeSeo.json";

export default function SeoIntro() {
  return (
    <section data-testid="service-areas-section" aria-label="Service areas" className="home-section home-section--band border-t" style={{ borderColor: "var(--line)", background: "var(--paper)" }}>
      <div className="container">
        <h2 data-testid="service-areas-heading" className="reveal font-heading text-[18px] md:text-[22px] font-bold leading-relaxed" style={{ color: "var(--green-950)" }}>
          Kapatia Pvt Ltd buys, sells and sources <span style={{ color: "var(--orange-700)" }}>IT &amp; office equipment</span> in Noida, Delhi NCR, Gurugram, Faridabad, Ghaziabad and Bangalore.
        </h2>
        <p data-testid="service-areas-description" className="reveal mt-3 max-w-[900px] text-[15px] md:text-[16px] leading-relaxed" style={{ color: "#31463a" }}>
          {HOME_SEO.introText}
        </p>
      </div>
    </section>
  );
}
